import { createEvent, sample, split } from 'effector'

import { PasswordForgotDialog } from './ui/password-forgot-dialog'
import { PasswordResetDialog } from './ui/password-reset-dialog'

export const resetPasswordClicked = createEvent<{ email: string }>()
export const forgotPasswordClicked = createEvent()

sample({
    clock: resetPasswordClicked,
    target: PasswordResetDialog.model.showFx,
})

sample({
    clock: forgotPasswordClicked,
    target: PasswordForgotDialog.model.showFx,
})

export const buttonClicked = createEvent<{ email: string }>()
split({
    source: buttonClicked,
    match: {
        reset: ({ email }) => email !== '',
        forgot: ({ email }) => email === '',
    },
    cases: {
        reset: PasswordResetDialog.model.showFx,
        forgot: PasswordForgotDialog.model.showFx,
    },
})
